/* partRegistrations.js */

"use strict";
const Steve = require("@gluenetworks/steve_core").getInstance();
const Registrations = require("../RegistrationNamespaces");
const Solutions = require("@gluenetworks/solution-definitions");
// const SolutionRegisterer = require("./solutionRegistrations");

// Register the solutions
// let registeredSolns = new SolutionRegisterer(Steve.di); //jshint ignore:line
Solutions.registerSolutions(Steve);

// Editor Section
const EditorSection = require("./SectionMgr");
Steve.di.registry.register(Registrations.GAME_CENTER_SECTION, EditorSection);

/****************/
/* DEVICE PARTS */
/****************/

/*** DEVICE EXPLORER ***/

const IOTDeviceExplorerEntity = require("./lmrbcomponents/iotdeviceexplorer/IotDeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB, IOTDeviceExplorerEntity);

const DeviceExplorerEntity = require("./lmrbcomponents/deviceexplorer/DeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ENTITY_LMRB, DeviceExplorerEntity);

const SiteExplorerEntity = require("./lmrbcomponents/siteexplorer/SiteExplorerEntityLmrbComponent");
Steve.di.registry.register(Registrations.SITE_EXPLORER_ENTITY_LMRB, SiteExplorerEntity);

/*** DEVICE EXPLORER - CONFIG DRIFT & AUDIT ONLY ***/

const ConfigDriftDeviceExplorerEntity = require("./lmrbcomponents/deviceexplorer/DeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(
    Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB,
    ConfigDriftDeviceExplorerEntity
);

const DeviceExplorerStatusBarView = require("./lmrbcomponents/deviceexplorer/views/file_server_status/FileServerStatusComponent");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_STATUS_BAR, DeviceExplorerStatusBarView);

/*** DEVICE EXPLORER - SWITCHERS ***/

const DieActionSwitchView = require("./lmrbcomponents/deviceexplorer/views/switch_to_config_audit/SwitchToConfigAuditComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_AUDIT_POLICY,
    DieActionSwitchView
);

const DieActionSwitchToPlatformExplorer = require("./lmrbcomponents/deviceexplorer/views/switch_to_platform_explorer/SwitchToPlatformComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER,
    DieActionSwitchToPlatformExplorer
);

const DieActionSwitchToOsPlanView = require("./lmrbcomponents/deviceexplorer/views/switch_to_os_plan/SwitchToOsPlanComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_PLAN,
    DieActionSwitchToOsPlanView
);

const DieActionSwitchToOsCatalogView = require("./lmrbcomponents/deviceexplorer/views/switch_to_os_catalog/SwitchToOsCatalogComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG,
    DieActionSwitchToOsCatalogView
);

const DieActionSwitchToDataExplorerView = require("./lmrbcomponents/deviceexplorer/views/switch_to_data_explorer/SwitchToDataExplorerComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_DATA_EXPLORER,
    DieActionSwitchToDataExplorerView
);

const DieActionSwitchToSiteExplorerView = require("./lmrbcomponents/deviceexplorer/views/switch_to_site_explorer/SwitchToSiteExplorerComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_SITE_EXPLORER,
    DieActionSwitchToSiteExplorerView
);

const NDActionSwitchToSiteExplorerView = require("./lmrbcomponents/networkdiscoveryexplorer/views/switch_to_site_explorer/SwitchToSiteExplorerComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EXPLORER_SWITCH_TO_SITE_EXPLORER,
    NDActionSwitchToSiteExplorerView
);

const DieActionSwitchToNetworkDiscoveryExplorerView = require("./lmrbcomponents/deviceexplorer/views/switch_to_network_discovery/SwitchToNetworkDiscoveryComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER,
    DieActionSwitchToNetworkDiscoveryExplorerView
);
const DieActionSwitchToIOTDeviceExplorerView = require("./lmrbcomponents/deviceexplorer/views/switch_to_iot_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
    DieActionSwitchToIOTDeviceExplorerView
);

/** IOT DEVICE EXPLORER */

const IOTDeviceExplorerGridView = require("./lmrbcomponents/iotdeviceexplorer/views/iot_device_grid_view/IotDeviceGridViewComponent");
Steve.di.registry.register(Registrations.IOT_DEVICE_EXPLORER_VIEW_GRID, IOTDeviceExplorerGridView);

const IOTDeviceExplorerActionSwitchView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.IOT_SWITCH_TO_DEVICE_EXPLORER,
    IOTDeviceExplorerActionSwitchView
);

const IOTDeviceExplorerActionSwitchToDataExplorerView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_data_explorer/SwitchToDataExplorerComponent");
Steve.di.registry.register(
    Registrations.IOT_SWITCH_TO_DATA_EXPLORER,
    IOTDeviceExplorerActionSwitchToDataExplorerView
);

const IOTDeviceExplorerSwitchToSiteExplorerView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_site_explorer/SwitchToSiteExplorerComponent");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_SWITCH_TO_SITE_EXPLORER,
    IOTDeviceExplorerSwitchToSiteExplorerView
);

const IOTDeviceExplorerSwitchToPlatformExplorerView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_platform_explorer/SwitchToPlatformComponent");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER,
    IOTDeviceExplorerSwitchToPlatformExplorerView
);

const IOTDeviceExplorerSwitchToNetworkDiscoveryExplorerView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_network_discovery/SwitchToNetworkDiscoveryComponent");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER,
    IOTDeviceExplorerSwitchToNetworkDiscoveryExplorerView
);

const IOTDeviceExplorerSwitchToOSPlanExplorerView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_os_plan/SwitchToOsPlanComponent");
Steve.di.registry.register(
    Registrations.IOT_SWITCH_TO_OS_PLAN_EXPLORER,
    IOTDeviceExplorerSwitchToOSPlanExplorerView
);

const IOTDeviceExplorerSwitchToCatalogExplorerView = require("./lmrbcomponents/iotdeviceexplorer/views/switch_to_os_catalog/SwitchToOsCatalogComponent");
Steve.di.registry.register(
    Registrations.IOT_SWITCH_TO_CATALOG_EXPLORER,
    IOTDeviceExplorerSwitchToCatalogExplorerView
);

/** IOT DEVICE EXPLORER */

/*** DEVICE EXPLORER VIEWS ***/

const DeviceExplorerGridView = require("./lmrbcomponents/deviceexplorer/views/device_grid_view/DeviceGridViewComponent");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_VIEW_GRID, DeviceExplorerGridView);

const SiteExplorerGridView = require("./lmrbcomponents/siteexplorer/views/site_grid_view/SiteGridViewComponent");
Steve.di.registry.register(Registrations.SITE_EXPLORER_VIEW_GRID, SiteExplorerGridView);

const NetworkDiscoveryExplorerGridView = require("./lmrbcomponents/networkdiscoveryexplorer/views/network_discovery_grid_view/NetworkDiscoveryGridViewComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EXPLORER_GRID,
    NetworkDiscoveryExplorerGridView
);

const NetworkDiscoveryExplorerEntity = require("./lmrbcomponents/networkdiscoveryexplorer/NetworkDiscoveryExplorerLmrbComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB,
    NetworkDiscoveryExplorerEntity
);

const NetworkDiscoveryActionSwitchView = require("./lmrbcomponents/networkdiscoveryexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_SWITCH_TO_DEVICE_EXPLORER,
    NetworkDiscoveryActionSwitchView
);

const NetworkDiscoveryActionSwitchToIotView = require("./lmrbcomponents/networkdiscoveryexplorer/views/switch_to_iot_device_explorer/SwitchToIotDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_SWITCH_TO_IOT_DEVICE_EXPLORER,
    NetworkDiscoveryActionSwitchToIotView
);

const NetworkDiscoveryDeviceExplorerEntity = require("./lmrbcomponents/deviceexplorer/DeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_DEVICE_EXPLORER_ENTITY_LMRB,
    NetworkDiscoveryDeviceExplorerEntity
);

const NetworkDiscoveryCreateAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_ACTION_CREATE,
    NetworkDiscoveryCreateAction
);

const NetworkDiscoveryCloneAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/clone/CloneAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_ACTION_CLONE,
    NetworkDiscoveryCloneAction
);

const NetworkDiscoveryDeleteAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_ACTION_DELETE,
    NetworkDiscoveryDeleteAction
);

const NetworkDiscoveryRunAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/runnetworkdiscovery/RunNetworkDiscoveryAction");
Steve.di.registry.register(Registrations.NETWORK_DISCOVERY_ACTION_RUN, NetworkDiscoveryRunAction);

const NetworkDiscoveryEditAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/edit/EditNetworkDiscoveryAction");
Steve.di.registry.register(Registrations.NETWORK_DISCOVERY_ACTION_EDIT, NetworkDiscoveryEditAction);

const NetworkDiscoveryExportAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/export/ExportAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_ACTION_EXPORT,
    NetworkDiscoveryExportAction
);

const NetworkDiscoveryImportAction = require("./lmrbcomponents/networkdiscoveryexplorer/actions/import/ImportAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_ACTION_IMPORT,
    NetworkDiscoveryImportAction
);

/*** DEVICE EXPLORER VIEWS - CONFIG DRIFT & AUDIT ALIAS ***/

const AuditPolicyDeviceExplorerGridView = require("./lmrbcomponents/deviceexplorer/views/device_grid_view/DeviceGridViewComponent");
Steve.di.registry.register(
    Registrations.CONFIG_AUDIT_DEVICE_VIEW_GRID,
    AuditPolicyDeviceExplorerGridView
);

/*** DEVICE EXPLORER ACTIONS ***/

const DeviceExplorerActionExport = require("./lmrbcomponents/deviceexplorer/actions/export/ExportAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_EXPORT, DeviceExplorerActionExport);

const DeviceExplorerActionReport = require("./lmrbcomponents/deviceexplorer/actions/report/ReportAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_REPORT, DeviceExplorerActionReport);

/*** DEVICE EXPLORER ACTIONS - DEVICE MANAGER ONLY ***/

const DeviceExplorerActionCreate = require("./lmrbcomponents/deviceexplorer/actions/create/CreateAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_CREATE, DeviceExplorerActionCreate);

const DeviceExplorerActionClone = require("./lmrbcomponents/deviceexplorer/actions/clone/CloneAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_CLONE, DeviceExplorerActionClone);

const DeviceExplorerActionDelete = require("./lmrbcomponents/deviceexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_DELETE, DeviceExplorerActionDelete);

const DeviceExplorerActionImport = require("./lmrbcomponents/deviceexplorer/actions/import/ImportAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_IMPORT, DeviceExplorerActionImport);

const DeviceViewMultiActionEdit = require("./lmrbcomponents/deviceexplorer/actions/multiedit/MultiEditAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_MULTIEDIT,
    DeviceViewMultiActionEdit
);

const DeviceExplorerDiscovery = require("./lmrbcomponents/deviceexplorer/actions/discovery/DiscoveryAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_DISCOVERY, DeviceExplorerDiscovery);

const DeviceExplorerAdhocQuery = require("./lmrbcomponents/deviceexplorer/actions/adhocquery/AdhocQueryAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_ADHOC_QUERY,
    DeviceExplorerAdhocQuery
);

const DeviceExplorerQualifyCves = require("./lmrbcomponents/deviceexplorer/actions/qualifycves/QualifyCvesAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_QUALIFY_CVES,
    DeviceExplorerQualifyCves
);

const DeviceExplorerUpdateCiscoAction = require("./lmrbcomponents/deviceexplorer/actions/updatecisco/UpdateCiscoSupportAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_UPDATE_CISCO,
    DeviceExplorerUpdateCiscoAction
);

const DeviceExplorerBackupAction = require("./lmrbcomponents/deviceexplorer/actions/backup/BackupAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_BACKUP, DeviceExplorerBackupAction);

const DeviceExplorerRestoreAction = require("./lmrbcomponents/deviceexplorer/actions/restore/RestoreAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_RESTORE,
    DeviceExplorerRestoreAction
);

const DeviceExplorerLinkAndSyncAction = require("./lmrbcomponents/deviceexplorer/actions/linkandsync/LinkAndSyncAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_LINK_AND_SYNC,
    DeviceExplorerLinkAndSyncAction
);

/*** DEVICE EXPLORER ACTIONS - CONFIG DRIFT & AUDIT ONLY ***/

/** IoT Device Explorer Actions */
const IoTDeviceExplorerActionExport = require("./lmrbcomponents/iotdeviceexplorer/actions/export/ExportAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_EXPORT,
    IoTDeviceExplorerActionExport
);

const IoTDeviceExplorerActionImport = require("./lmrbcomponents/iotdeviceexplorer/actions/import/ImportAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_IMPORT,
    IoTDeviceExplorerActionImport
);

const IotDeviceExplorerOfflineDiscoveryDownloadAction = require("./lmrbcomponents/iotdeviceexplorer/actions/offlinediscoverydownload/OfflineDiscoveryDownloadAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_OFFLINE_DISCOVERY_DOWNLOAD,
    IotDeviceExplorerOfflineDiscoveryDownloadAction
);

const IotDeviceExplorerOfflineDiscoveryUploadAction = require("./lmrbcomponents/iotdeviceexplorer/actions/offlinediscoveryupload/OfflineDiscoveryUploadAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_OFFLINE_DISCOVERY_UPLOAD,
    IotDeviceExplorerOfflineDiscoveryUploadAction
);

const IotDeviceExplorerAddOsPlanAction = require("./lmrbcomponents/iotdeviceexplorer/actions/createosplan/CreateOdmOsPlanAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_ADD_OS_PLAN,
    IotDeviceExplorerAddOsPlanAction
);

const IotDeviceViewMultiActionEdit = require("./lmrbcomponents/iotdeviceexplorer/actions/multiedit/MultiEditAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_MULTIEDIT,
    IotDeviceViewMultiActionEdit
);

const IotDeviceExplorerLinkAndSyncAction = require("./lmrbcomponents/iotdeviceexplorer/actions/linkandsync/LinkAndSyncAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_LINK_AND_SYNC,
    IotDeviceExplorerLinkAndSyncAction
);

const IotDeviceExplorerActionReport = require("./lmrbcomponents/iotdeviceexplorer/actions/report/ReportAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_REPORT,
    IotDeviceExplorerActionReport
);

const IotDeviceExplorerActionCopy = require("./lmrbcomponents/iotdeviceexplorer/actions/copy/CopyAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_COPY,
    IotDeviceExplorerActionCopy
);

const IotDeviceExplorerActionDelete = require("./lmrbcomponents/iotdeviceexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.IOT_DEVICE_EXPLORER_ACTION_DELETE,
    IotDeviceExplorerActionDelete
);

/** IoT Device Explorer Actions */

const DeviceExplorerCapture = require("./lmrbcomponents/deviceexplorer/actions/capture/CaptureAction");
Steve.di.registry.register(Registrations.DEVICE_EXPLORER_ACTION_CAPTURE, DeviceExplorerCapture);

const DeviceExplorerSetDefaultConfigAction = require("./lmrbcomponents/deviceexplorer/actions/setdefaultconfig/SetDefaultConfigAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_SET_DEFAULT_CONFIG,
    DeviceExplorerSetDefaultConfigAction
);

const DeviceViewConfigureAuditAction = require("./lmrbcomponents/deviceexplorer/actions/configureaudit/ConfigureAuditAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_CONFIGURE_AUDIT,
    DeviceViewConfigureAuditAction
);

/*** DEVICE EXPLORER ACTIONS - OS MANAGER ONLY ***/

const DieActionCreateOsPlan = require("./lmrbcomponents/deviceexplorer/actions/createosplan/CreateOsPlanAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_CREATE_OS_PLAN,
    DieActionCreateOsPlan
);

const DieActionRebootDevice = require("./lmrbcomponents/deviceexplorer/actions/rebootdevice/RebootDeviceAction");
Steve.di.registry.register(
    Registrations.DEVICE_EXPLORER_ACTION_REBOOT_DEVICE,
    DieActionRebootDevice
);

/*** SITE EXPLORER ACTIONS ***/

const siteExplorerActionCreateSite = require("./lmrbcomponents/siteexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.SITE_EXPLORER_ACTION_CREATE_SITE,
    siteExplorerActionCreateSite
);

const siteExplorerSwitchToNetworkDiscovery = require("./lmrbcomponents/siteexplorer/views/switch_to_network_discovery/SwitchToNetworkDiscoveryComponent");
Steve.di.registry.register(
    Registrations.SITE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER,
    siteExplorerSwitchToNetworkDiscovery
);

const siteExplorerActionDelete = require("./lmrbcomponents/siteexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.SITE_EXPLORER_ACTION_DELETE, siteExplorerActionDelete);

const siteExplorerActionExport = require("./lmrbcomponents/siteexplorer/actions/export/ExportAction");
Steve.di.registry.register(Registrations.SITE_EXPLORER_ACTION_EXPORT, siteExplorerActionExport);

const siteExplorerActionImport = require("./lmrbcomponents/siteexplorer/actions/import/ImportAction");
Steve.di.registry.register(Registrations.SITE_EXPLORER_ACTION_IMPORT, siteExplorerActionImport);

const siteExplorerActionClone = require("./lmrbcomponents/siteexplorer/actions/clone/CloneAction");
Steve.di.registry.register(Registrations.SITE_EXPLORER_ACTION_CLONE, siteExplorerActionClone);

const SiteViewMultiActionEdit = require("./lmrbcomponents/siteexplorer/actions/multiedit/MultiEditAction");
Steve.di.registry.register(Registrations.SITE_EXPLORER_ACTION_MULTIEDIT, SiteViewMultiActionEdit);

const SiteExplorerActionAutoAssignment = require("./lmrbcomponents/siteexplorer/actions/autoassignment/AutoAssignmentAction");
Steve.di.registry.register(
    Registrations.SITE_EXPLORER_ACTION_AUTO_ASSIGNMENT,
    SiteExplorerActionAutoAssignment
);

/*** DEVICE EDITOR ***/

const Die = require("./editors/deviceinstanceeditor/DeviceInstanceEditor");
Steve.di.registry.register(Registrations.DEVICE_INSTANCE_EDITOR, Die);

/*** DEVICE EDITOR VIEWS ***/

const DieViewDetails = require("./editors/deviceinstanceeditor/views/device_details/DeviceDetailsViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_DETAILS, DieViewDetails);

const HaGroupDevice = require("./editors/deviceinstanceeditor/views/device_details/subviews/ha_group/HaGroupViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_DETAILS_SUBVIEW_HA_GROUP, HaGroupDevice);

const DieViewActivity = require("./editors/deviceinstanceeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_ACTIVITY, DieViewActivity);

const DieViewRestore = require("./editors/deviceinstanceeditor/views/device_restore/DeviceRestoreViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_RESTORE, DieViewRestore);

const DieAuditSummary = require("./editors/deviceinstanceeditor/views/audit_summary/AuditSummaryComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_AUDIT_SUMMARY, DieAuditSummary);

/*** DEVICE EDITOR VIEWS - DEVICE MANAGER ONLY ***/

const DieViewMultiEdit = require("./editors/deviceinstanceeditor/views/device_multiedit/DeviceMultiEditViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_MULTIEDIT, DieViewMultiEdit);

const DieViewEoxBulletin = require("./editors/deviceinstanceeditor/views/eox_bulletin/EoxBulletinViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_EOX_BULLETIN, DieViewEoxBulletin);

const DieViewSmartnetDetails = require("./editors/deviceinstanceeditor/views/smartnet_details/SmartnetDetailsViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_SMARTNET_DETAILS, DieViewSmartnetDetails);

const DieViewAdvisorySummary = require("./editors/deviceinstanceeditor/views/advisory_summary/AdvisoryViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_ADVISORY_SUMMARY, DieViewAdvisorySummary);

const DieViewAdvisoryDetails = require("./editors/deviceinstanceeditor/views/advisory_summary/subviews/advisory_details/AdvisoryDetailsViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_ADVISORY_DETAILS, DieViewAdvisoryDetails);

const DieViewExposure = require("./editors/deviceinstanceeditor/views/exposure/ExposureViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_EXPOSURE, DieViewExposure);

const DieViewExposureDetails = require("./editors/deviceinstanceeditor/views/exposure/subviews/exposure_details/ExposureDetailsViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_EXPOSURE_DETAILS, DieViewExposureDetails);

/*** DEVICE EDITOR VIEWS - CONFIG DRIFT & AUDIT ONLY ***/

const DieViewCompare = require("./editors/deviceinstanceeditor/views/compare/CompareViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_COMPARE, DieViewCompare);

const DieViewSnapshot = require("./editors/deviceinstanceeditor/views/snapshot/DeviceConfigurationSnapshotViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_SNAPSHOT, DieViewSnapshot);

const DieViewEditSnapshot = require("./editors/deviceinstanceeditor/views/snapshot/subviews/edit_snapshot/EditSnapshotViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_EDIT_SNAPSHOT, DieViewEditSnapshot);

const DieViewConfig = require("./editors/deviceinstanceeditor/views/config/ConfigViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_CONFIG, DieViewConfig);

const DieViewState = require("./editors/deviceinstanceeditor/views/state/StateViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_STATE, DieViewState);

const DieViewNotes = require("./editors/deviceinstanceeditor/views/activity/subviews/notes/NotesViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_NOTES, DieViewNotes);

const DieViewJob = require("./editors/deviceinstanceeditor/views/activity/subviews/job/JobViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_JOB, DieViewJob);

const DieViewLogs = require("./editors/deviceinstanceeditor/views/activity/subviews/logs/LogsViewComponent");
Steve.di.registry.register(Registrations.DIE_VIEW_LOGS, DieViewLogs);

/*** DEVICE EDITOR ACTIONS - DEVICE MANAGER ONLY ***/

const DieActionDiscovery = require("./editors/deviceinstanceeditor/actions/discovery/DiscoveryAction");
Steve.di.registry.register(Registrations.DIE_ACTION_DISCOVERY, DieActionDiscovery);

const DieActionBackup = require("./editors/deviceinstanceeditor/actions/devicebackup/BackupAction");
Steve.di.registry.register(Registrations.DIE_ACTION_BACKUP, DieActionBackup);

const DieActionDelete = require("./editors/deviceinstanceeditor/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.DIE_ACTION_DELETE, DieActionDelete);

/*** DEVICE EDITOR ACTIONS - CONFIG DRIFT & AUDIT ONLY ***/

const DieActionConfigAudit = require("./editors/deviceinstanceeditor/actions/configAudit/ConfigAuditAction");
Steve.di.registry.register(Registrations.DIE_ACTION_CONFIG_AUDIT, DieActionConfigAudit);

const DieActionCapture = require("./editors/deviceinstanceeditor/actions/capture/CaptureAction");
Steve.di.registry.register(Registrations.DIE_ACTION_CAPTURE, DieActionCapture);

const DieActionSetDefaultConfig = require("./editors/deviceinstanceeditor/actions/setdefaultconfig/SetDefaultConfigAction");
Steve.di.registry.register(Registrations.DIE_ACTION_SET_DEFAULT_CONFIG, DieActionSetDefaultConfig);

/*** SITE EDITOR ***/

const Site = require("./editors/siteinstanceeditor/SiteInstanceEditor");
Steve.di.registry.register(Registrations.SITE_INSTANCE_EDITOR, Site);

/*** SITE EDITOR VIEWS ***/

const SieViewDetails = require("./editors/siteinstanceeditor/views/site_details/SiteDetailsViewComponent");
Steve.di.registry.register(Registrations.SIE_VIEW_DETAILS, SieViewDetails);

const SieViewSitesView = require("./editors/siteinstanceeditor/views/sites/SitesViewComponent");
Steve.di.registry.register(Registrations.SIE_VIEW_SITES, SieViewSitesView);

const SieViewDevicesView = require("./editors/siteinstanceeditor/views/devices/DevicesViewComponent");
Steve.di.registry.register(Registrations.SIE_VIEW_DEVICES, SieViewDevicesView);

const SieViewActivity = require("./editors/siteinstanceeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.SIE_VIEW_ACTIVITY, SieViewActivity);

/*** SITE EDITOR ACTIONS ***/

const SieActionDelete = require("./editors/siteinstanceeditor/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.SIE_ACTION_DELETE, SieActionDelete);

const SieViewMultiEdit = require("./editors/siteinstanceeditor/views/site_multiedit/SiteMultiEditViewComponent");
Steve.di.registry.register(Registrations.SIE_VIEW_MULTIEDIT, SieViewMultiEdit);

/***************************/
/* NETWORK DISCOVERY PARTS */
/***************************/

/***  NETWORK DISCOVERY EDITOR ***/

const NetworkDiscoveryEditor = require("./editors/networkdiscoveryeditor/NetworkDiscoveryEditor");
Steve.di.registry.register(Registrations.NETWORK_DISCOVERY_EDITOR, NetworkDiscoveryEditor);

/***  NETWORK DISCOVERY EDITOR VIEWS ***/

const NetworkDiscoveryViewDetails = require("./editors/networkdiscoveryeditor/views/network_discovery_details/NetworkDiscoveryDetailsViewComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS,
    NetworkDiscoveryViewDetails
);

const NetworkDiscoveryViewHistory = require("./editors/networkdiscoveryeditor/views/network_discovery_history/NetworkDiscoveryHistoryViewComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_HISTORY,
    NetworkDiscoveryViewHistory
);

const NetworkDiscoveryViewHistoryLogs = require("./editors/networkdiscoveryeditor/views/network_discovery_history/subviews/executionLog/ExecutionLogComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_SUBVIEW_EXECUTION_LOG,
    NetworkDiscoveryViewHistoryLogs
);

const NetworkDiscoveryViewResults = require("./editors/networkdiscoveryeditor/views/network_discovery_results/NetworkDiscoveryResultsViewComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_RESULTS,
    NetworkDiscoveryViewResults
);

const NetworkDiscoveryViewActivity = require("./editors/networkdiscoveryeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_VIEW_ACTIVITY,
    NetworkDiscoveryViewActivity
);

const NetworkDiscoveryResultLogs = require("./editors/networkdiscoveryeditor/views/network_discovery_results/subviews/logs/LogsViewComponent");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_SUBVIEW_RESULTS_LOGS,
    NetworkDiscoveryResultLogs
);

const NetworkDiscoveryActionRun = require("./editors/networkdiscoveryeditor/actions/runnetworkdiscovery/RunNetworkDiscoveryAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_ACTION_RUN,
    NetworkDiscoveryActionRun
);

const NetworkDiscoveryActionDelete = require("./editors/networkdiscoveryeditor/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.NETWORK_DISCOVERY_EDITOR_ACTION_DELETE,
    NetworkDiscoveryActionDelete
);

/***  NETWORK DISCOVERY EDITOR ***/

const AdhocQueryEditor = require("./editors/adhocqueryeditor/AdhocQueryEditor");
Steve.di.registry.register(Registrations.ADHOC_QUERY_EDITOR, AdhocQueryEditor);

/*** Ad-hoc Query Views */

const AdhocQueryViewDetails = require("./editors/adhocqueryeditor/views/adhoc_query_details/AdhocQueryDetailsViewComponent");
Steve.di.registry.register(Registrations.ADHOC_QUERY_EDITOR_VIEW_DETAILS, AdhocQueryViewDetails);

/********************/
/* PLATFORM EDITOR  */
/********************/
const PlatformEditorEntityLmrb = require("./editors/odmosplatforminstanceeditor/OdmOsPlatformInstanceEditor");
Steve.di.registry.register(Registrations.ODM_OS_PLATFORM_EDITOR, PlatformEditorEntityLmrb);

const PlatformEditorEntityLmrbViewDetails = require("./editors/odmosplatforminstanceeditor/views/odm_os_platform_details/OdmOsPlatformDetailsViewComponent");
Steve.di.registry.register(
    Registrations.ODM_OS_PLATFORM_EDITOR_VIEW_DETAILS,
    PlatformEditorEntityLmrbViewDetails
);

const PlatformEditorEntityLmrbViewActivity = require("./editors/odmosplatforminstanceeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(
    Registrations.ODM_OS_PLATFORM_EDITOR_VIEW_ACTIVITY,
    PlatformEditorEntityLmrbViewActivity
);

const PlatformEditorActionDelete = require("./editors/odmosplatforminstanceeditor/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.ODM_OS_PLATFORM_EDITOR_ACTION_DELETE,
    PlatformEditorActionDelete
);

const OdmOsPlatformEditorUploadImage = require("./editors/odmosplatforminstanceeditor/actions/uploadimage/UploadImageAction");
Steve.di.registry.register(
    Registrations.ODM_OS_PLATFORM_EDITOR_ACTIONS_UPLOAD_IMAGE,
    OdmOsPlatformEditorUploadImage
);

const OdmOsPlatformEditorAddImage = require("./actions/addimages/AddImagesAction");
Steve.di.registry.register(
    Registrations.ODM_OS_PLATFORM_EDITOR_ACTIONS_ADD_IMAGES,
    OdmOsPlatformEditorAddImage
);

const PlatformActivityLogs = require("./editors/odmosplatforminstanceeditor/views/activity/subviews/logs/LogsViewComponent");
Steve.di.registry.register(
    Registrations.ODM_OS_PLATFORM_EDITOR_SUBVIEW_ACTIVITY_LOGS,
    PlatformActivityLogs
);

/********************/
/* PLATFORM EXPLORER */
/********************/

const PlatformExplorerEntityLmrb = require("./lmrbcomponents/platformexplorer/PlatformExplorerEntityLmrbComponent");
Steve.di.registry.register(Registrations.PLATFORM_EXPLORER_LMRB, PlatformExplorerEntityLmrb);

const PlatformExplorerView = require("./lmrbcomponents/platformexplorer/views/platform_grid_view/PlatformGridViewComponent");
Steve.di.registry.register(Registrations.PLATFORM_EXPLORER_GRID, PlatformExplorerView);

const PlatformExplorerSwitchToDeviceExplorer = require("./lmrbcomponents/platformexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    PlatformExplorerSwitchToDeviceExplorer
);

const PlatformExplorerSwitchToIoTDeviceExplorer = require("./lmrbcomponents/platformexplorer/views/switch_to_iot_device_explorer/SwitchToIotDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.PLATFORM_SWITCH_TO_IOT_DEVICE_EXPLORER,
    PlatformExplorerSwitchToIoTDeviceExplorer
);

const PlatformExplorerSwitchToOsPlanExplorer = require("./lmrbcomponents/platformexplorer/views/switch_to_iot_os_plan_explorer/SwitchToIotOsPlanExplorerComponent");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
    PlatformExplorerSwitchToOsPlanExplorer
);

const PlatformExplorerSwitchToOsPlanView = require("./lmrbcomponents/platformexplorer/views/switch_to_os_plan/SwitchToOsPlanComponent");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_SWITCH_TO_OS_PLAN,
    PlatformExplorerSwitchToOsPlanView
);

const PlatformExplorerSwitchToCatalog = require("./lmrbcomponents/platformexplorer/views/switch_to_os_catalog/SwitchToOsCatalogComponent");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_SWITCH_TO_OS_CATALOG,
    PlatformExplorerSwitchToCatalog
);

/*** PLATFORM EXPLORER ACTIONS ***/

const PlatformExplorerActionCreate = require("./lmrbcomponents/platformexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_ACTION_CREATE,
    PlatformExplorerActionCreate
);

const PlatformExplorerActionDelete = require("./lmrbcomponents/platformexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_ACTION_DELETE,
    PlatformExplorerActionDelete
);

const PlatformExplorerActionEdit = require("./lmrbcomponents/platformexplorer/actions/edit/EditAction");
Steve.di.registry.register(Registrations.PLATFORM_EXPLORER_ACTION_EDIT, PlatformExplorerActionEdit);

const PlatformExplorerActionAddImages = require("./actions/addimages/AddImagesAction");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_ACTION_ADD_IMAGES,
    PlatformExplorerActionAddImages
);

const PlatformExplorerActionAddInstructions = require("./actions/addinstructions/AddInstructionsAction");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_ACTION_ADD_INSTRUCTIONS,
    PlatformExplorerActionAddInstructions
);

const PlatformExplorerActionFindImages = require("./lmrbcomponents/platformexplorer/actions/findimages/FindImagesAction");
Steve.di.registry.register(
    Registrations.PLATFORM_EXPLORER_ACTION_FIND_IMAGES,
    PlatformExplorerActionFindImages
);

/********************/
/* OS CATALOG PARTS */
/*******************/

/*** OS CATALOG EXPLORER ***/

const OsCatalogExplorerLmrb = require("./lmrbcomponents/oscatalogexplorer/OsCatalogExplorerLmrbComponent");
Steve.di.registry.register(Registrations.OS_CATALOG_EXPLORER_LMRB, OsCatalogExplorerLmrb);

/*** OS CATALOG EXPLORER VIEWS ***/

const OsCatalogExplorerView = require("./lmrbcomponents/oscatalogexplorer/views/os_catalog_grid_view/OsCatalogGridViewComponent");
Steve.di.registry.register(Registrations.OS_CATALOG_EXPLORER_GRID, OsCatalogExplorerView);

const OsCatalogActionSwitchView = require("./lmrbcomponents/oscatalogexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    OsCatalogActionSwitchView
);

const OsCatalogActionSwitchToPlatformExplorerView = require("./lmrbcomponents/oscatalogexplorer/views/switch_to_platform_explorer/SwitchToPlatformComponent");
Steve.di.registry.register(
    Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER,
    OsCatalogActionSwitchToPlatformExplorerView
);

const OsCatalogActionSwitchToIoTDeviceExplorerView = require("./lmrbcomponents/oscatalogexplorer/views/switch_to_iot_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.OS_CATALOG_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
    OsCatalogActionSwitchToIoTDeviceExplorerView
);

/*** OS CATALOG EXPLORER ACTIONS ***/

const DieActionCreateOsCatalog = require("./lmrbcomponents/oscatalogexplorer/actions/create/CreateAction");
Steve.di.registry.register(Registrations.CATALOG_EXPLORER_ACTION_CREATE, DieActionCreateOsCatalog);

const DieActionEditOsCatalog = require("./lmrbcomponents/oscatalogexplorer/actions/edit/EditAction");
Steve.di.registry.register(Registrations.CATALOG_EXPLORER_ACTION_EDIT, DieActionEditOsCatalog);

const DieActionCloneOsCatalog = require("./lmrbcomponents/oscatalogexplorer/actions/clone/CloneAction");
Steve.di.registry.register(Registrations.CATALOG_EXPLORER_ACTION_CLONE, DieActionCloneOsCatalog);

const DieActionDeleteOsCatalog = require("./lmrbcomponents/oscatalogexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.CATALOG_EXPLORER_ACTION_DELETE, DieActionDeleteOsCatalog);

const DieActionExportOsCatalog = require("./lmrbcomponents/oscatalogexplorer/actions/export/ExportAction");
Steve.di.registry.register(Registrations.CATALOG_EXPLORER_ACTION_EXPORT, DieActionExportOsCatalog);

/*** OS CATALOG EDITOR ***/

const OsCatalogEditor = require("./editors/oscatalogeditor/OsCatalogEditor");
Steve.di.registry.register(Registrations.OS_CATALOG_EDITOR, OsCatalogEditor);

/*** OS CATALOG EDITOR VIEWS ***/

const OsCatalogDetailsView = require("./editors/oscatalogeditor/views/os_catalog_details/OsCatalogDetailsViewComponent");
Steve.di.registry.register(Registrations.OS_CATALOG_EDITOR_VIEW_DETAILS, OsCatalogDetailsView);

const OsCatalogActivityView = require("./editors/oscatalogeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.OS_CATALOG_EDITOR_VIEW_ACTIVITY, OsCatalogActivityView);

/*** OS CATALOG EDITOR ACTIONS ***/

const OsCatalogEditorActionExport = require("./editors/oscatalogeditor/actions/export/ExportAction");
Steve.di.registry.register(
    Registrations.OS_CATALOG_EDITOR_ACTIONS_EXPORT,
    OsCatalogEditorActionExport
);

const OsCatalogEditorActionDelete = require("./editors/oscatalogeditor/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.OS_CATALOG_EDITOR_ACTIONS_DELETE,
    OsCatalogEditorActionDelete
);

const OsManagerDeviceExplorerEntity = require("./lmrbcomponents/deviceexplorer/DeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(
    Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB,
    OsManagerDeviceExplorerEntity
);

const OsManagerIoTDeviceExplorerEntity = require("./lmrbcomponents/iotdeviceexplorer/IotDeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(
    Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB,
    OsManagerIoTDeviceExplorerEntity
);

/*****************/
/* OS PLAN PARTS */
/*****************/

/*** OS PLAN EXPLORER ***/

const OsPlanExplorerLmrb = require("./lmrbcomponents/osplanexplorer/OsPlanExplorerLmrbComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EXPLORER_LMRB, OsPlanExplorerLmrb);

/*** OS PLAN EXPLORER VIEWS ***/

const OsPlanExplorerView = require("./lmrbcomponents/osplanexplorer/views/os_plan_grid_view/OsPlanGridViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EXPLORER_GRID, OsPlanExplorerView);

const OsPlanStatusBarView = require("./lmrbcomponents/osplanexplorer/views/file_server_status/FileServerStatusComponent");
Steve.di.registry.register(Registrations.OS_PLAN_STATUS_BAR, OsPlanStatusBarView);

const OsPlanActionSwitchView = require("./lmrbcomponents/osplanexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.OS_PLAN_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    OsPlanActionSwitchView
);

const OsPlanActionSwitchToIoTExplorerView = require("./lmrbcomponents/osplanexplorer/views/switch_to_iot_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER,
    OsPlanActionSwitchToIoTExplorerView
);

const OsPlanActionSwitchToPlatformExplorerView = require("./lmrbcomponents/osplanexplorer/views/switch_to_platform_explorer/SwitchToPlatformComponent");
Steve.di.registry.register(
    Registrations.OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER,
    OsPlanActionSwitchToPlatformExplorerView
);

const OsPlanActionSwitchToIotOsPlanExplorerView = require("./lmrbcomponents/osplanexplorer/views/switch_to_iot_os_plan_explorer/SwitchToIotOsPlanExplorerComponent");
Steve.di.registry.register(
    Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER,
    OsPlanActionSwitchToIotOsPlanExplorerView
);

/*** OS PLAN EXPLORER ACTIONS ***/

const OsPlanExplorerActionCreate = require("./lmrbcomponents/osplanexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.OS_PLAN_EXPLORER_ACTIONS_CREATE,
    OsPlanExplorerActionCreate
);

const OsPlanExplorerActionDelete = require("./lmrbcomponents/osplanexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.OS_PLAN_EXPLORER_ACTIONS_DELETE,
    OsPlanExplorerActionDelete
);

const OsPlanExplorerActionClone = require("./lmrbcomponents/osplanexplorer/actions/clone/CloneAction");
Steve.di.registry.register(Registrations.OS_PLAN_EXPLORER_ACTIONS_CLONE, OsPlanExplorerActionClone);

const OsPlanExplorerActionExport = require("./lmrbcomponents/osplanexplorer/actions/export/ExportAction");
Steve.di.registry.register(
    Registrations.OS_PLAN_EXPLORER_ACTIONS_EXPORT,
    OsPlanExplorerActionExport
);

const OsPlanExplorerActionEdit = require("./lmrbcomponents/osplanexplorer/actions/edit/EditAction");
Steve.di.registry.register(Registrations.OS_PLAN_EXPLORER_ACTIONS_EDIT, OsPlanExplorerActionEdit);

const OsPlanExplorerActionRun = require("./lmrbcomponents/osplanexplorer/actions/run/RunAction");
Steve.di.registry.register(Registrations.OS_PLAN_EXPLORER_ACTIONS_RUN, OsPlanExplorerActionRun);

/*** OS PLAN EDITOR ***/

const OsPlanEditor = require("./editors/osplaneditor/OsPlanEditor");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR, OsPlanEditor);

/*** OS PLAN EDITOR VIEWS ***/

const OsPlanDetails = require("./editors/osplaneditor/views/os_plan_details/OsPlanDetailsViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_VIEW_DETAILS, OsPlanDetails);

const OsPlanResults = require("./editors/osplaneditor/views/os_plan_results/OsPlanResultsViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_VIEW_RESULTS, OsPlanResults);

const OsPlanActivity = require("./editors/osplaneditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_VIEW_ACTIVITY, OsPlanActivity);

const OsPlanImageDetails = require("./editors/osplaneditor/views/os_plan_details/subviews/image_details/ImageDetailsComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_SUBVIEW_IMAGE_DETAILS, OsPlanImageDetails);

const OsPlanValidation = require("./editors/osplaneditor/views/os_plan_details/subviews/validate/ValidateViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_SUBVIEW_VALIDATE, OsPlanValidation);

const OsPlanResultLogs = require("./editors/osplaneditor/views/os_plan_results/subviews/logs/LogsViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_SUBVIEW_RESULTS_LOGS, OsPlanResultLogs);

const OsPlanActivityLogs = require("./editors/osplaneditor/views/activity/subviews/logs/LogsViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_SUBVIEW_ACTIVITY_LOGS, OsPlanActivityLogs);

const OsPlanManageDevice = require("./editors/osplaneditor/views/os_plan_details/subviews/manage_device/ManageDeviceViewComponent");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_SUBVIEW_MANAGE_DEVICE, OsPlanManageDevice);

/*** OS PLAN EDITOR ACTIONS ***/

const OsPlanEditorDelete = require("./editors/osplaneditor/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_ACTIONS_DELETE, OsPlanEditorDelete);

const OsPlanEditorRun = require("./editors/osplaneditor/actions/run/RunAction");
Steve.di.registry.register(Registrations.OS_PLAN_EDITOR_ACTIONS_RUN, OsPlanEditorRun);

/**********************/
/* AUDIT POLICY PARTS */
/**********************/

/*** AUDIT EXPLORER ***/

const AuditPolicyExplorerLmrb = require("./lmrbcomponents/auditpolicyexplorer/AuditPolicyExplorerLmrbComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EXPLORER_LMRB, AuditPolicyExplorerLmrb);

/*** AUDIT POLICY EXPLORER VIEWS ***/

const AuditPolicyExplorerView = require("./lmrbcomponents/auditpolicyexplorer/views/audit_policy_grid_view/AuditPolicyGridViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EXPLORER_GRID, AuditPolicyExplorerView);

const AuditPolicyActionSwitchView = require("./lmrbcomponents/auditpolicyexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    AuditPolicyActionSwitchView
);

const SiteActionSwitchView = require("./lmrbcomponents/siteexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.SITE_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    SiteActionSwitchView
);

const SiteActionSwitchToIotView = require("./lmrbcomponents/siteexplorer/views/switch_to_iot_device_explorer/SwitchToIotDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.SITE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
    SiteActionSwitchToIotView
);

/*** AUDIT POLICY EXPLORER ACTIONS */

const AuditPolicyExplorerActionCreate = require("./lmrbcomponents/auditpolicyexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EXPLORER_ACTION_CREATE,
    AuditPolicyExplorerActionCreate
);

const AuditPolicyExplorerActionClone = require("./lmrbcomponents/auditpolicyexplorer/actions/clone/CloneAction");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EXPLORER_ACTION_CLONE,
    AuditPolicyExplorerActionClone
);

const AuditPolicyExplorerActionImport = require("./lmrbcomponents/auditpolicyexplorer/actions/import/ImportAction");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EXPLORER_ACTION_IMPORT,
    AuditPolicyExplorerActionImport
);

const AuditPolicyExplorerActionExport = require("./lmrbcomponents/auditpolicyexplorer/actions/export/ExportAction");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EXPLORER_ACTION_EXPORT,
    AuditPolicyExplorerActionExport
);

const AuditPolicyExplorerActionDelete = require("./lmrbcomponents/auditpolicyexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EXPLORER_ACTION_DELETE,
    AuditPolicyExplorerActionDelete
);

/*** AUDIT POLICY EDITOR */

const AuditPolicyEditor = require("./editors/auditpolicyeditor/AuditPolicyEditor");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR, AuditPolicyEditor);

/*** AUDIT POLICY EDITOR VIEWS */

const AuditPolicyDetails = require("./editors/auditpolicyeditor/views/audit_policy_details/AuditPolicyDetailsViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR_VIEW_DETAILS, AuditPolicyDetails);

const AuditPolicyResults = require("./editors/auditpolicyeditor/views/audit_policy_results/AuditPolicyResultsViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS, AuditPolicyResults);

const AuditPolicyVersions = require("./editors/auditpolicyeditor/views/audit_policy_versions/AuditPolicyVersionsViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR_VIEW_VERSIONS, AuditPolicyVersions);

const AuditPolicyActivity = require("./editors/auditpolicyeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR_VIEW_ACTIVITY, AuditPolicyActivity);

const AuditPolicyHistory = require("./editors/auditpolicyeditor/views/audit_policy_history/HistoryViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR_VIEW_HISTORY, AuditPolicyHistory);

const AuditPolicyCompare = require("./editors/auditpolicyeditor/views/audit_policy_versions/subview/compare/CompareViewComponent");
Steve.di.registry.register(Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_COMPARE, AuditPolicyCompare);

/*** AUDIT POLICY EDITOR SUBVIEWS */

const AuditPolicyExecutionLog = require("./editors/auditpolicyeditor/views/audit_policy_history/subviews/executionLog/ExecutionLogComponent");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_EXECUTION_LOG,
    AuditPolicyExecutionLog
);

const AuditPolicyTargetDevicesList = require("./editors/auditpolicyeditor/views/audit_policy_history/subviews/targetDevicesList/TargetDevicesListComponent");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_TARGET_DEVICES_LIST,
    AuditPolicyTargetDevicesList
);

const AuditPolicyDetailsSubview = require("./editors/auditpolicyeditor/views/audit_policy_history/subviews/policyDetails/PolicyDetailsSubviewComponent");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EDITOR_SUBVIEW_DETAILS_VIEW,
    AuditPolicyDetailsSubview
);

/*** AUDIT POLICY EDITOR ACTIONS */

const AuditPolicyActionDelete = require("./editors/auditpolicyeditor/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.AUDIT_POLICY_EDITOR_ACTIONS_DELETE,
    AuditPolicyActionDelete
);

/*************************/
/* WIZARD EXPLORER PARTS */
/*************************/

/*** WIZARD EXPLORER ***/

const WizardExplorer = require("./lmrbcomponents/wizardexplorer/WizardExplorerLmrbComponent");
Steve.di.registry.register(Registrations.WIZARD_EXPLORER_LMRB, WizardExplorer);

/*** WIZARD EDITOR ***/

const WizardExplorerListView = require("./lmrbcomponents/wizardexplorer/views/wizardtreeview/WizardTreeViewComponent");
Steve.di.registry.register(Registrations.WIZARD_EXPLORER_VIEW_LIST, WizardExplorerListView);

/*****************/
/* PACKAGE PARTS */
/*****************/

/*** PACKAGE EXPLORER ***/

const PackageExplorer = require("./lmrbcomponents/packageexplorer/PackageExplorerLmrbComponent");
Steve.di.registry.register(Registrations.PACKAGE_EXPLORER_LMRB, PackageExplorer);

const PackageStatusBarView = require("./lmrbcomponents/packageexplorer/packageStatus/DistCenterStatusComponent");
Steve.di.registry.register(Registrations.PACKAGE_EXPLORER_STATUS_BAR, PackageStatusBarView);

/*** PACKAGE EDITOR ***/

const Pe = require("./editors/packageeditor/PackageEditorComponent");
Steve.di.registry.register(Registrations.PACKAGE_EDITOR, Pe);

/**********************/
/* WORK TRIGGER PARTS */
/**********************/

/*** WORK TRIGGER EXPLORER ***/

const WorkTriggerExplorerEntity = require("./lmrbcomponents/worktrigexplorer/WorkTrigEntityExplorerLmrbComponent");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_ENTITY_LMRB,
    WorkTriggerExplorerEntity
);

/*** WORK TRIGGER EXPLORER VIEWS ***/

const WorkTriggerExplorerGridView = require("./lmrbcomponents/worktrigexplorer/views/worktrig_grid_view/WorkTrigGridViewComponent");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_VIEW_GRID,
    WorkTriggerExplorerGridView
);

/*** WORK TRIGGER EXPLORER ACTIONS ***/

const WorkTriggerExplorerActionRun = require("./lmrbcomponents/worktrigexplorer/actions/run/RunAction");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_ACTION_RUN,
    WorkTriggerExplorerActionRun
);

const WorkTriggerExplorerActionPause = require("./lmrbcomponents/worktrigexplorer/actions/pause/PauseAction");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_ACTION_PAUSE,
    WorkTriggerExplorerActionPause
);

const WorkTriggerExplorerActionCreate = require("./lmrbcomponents/worktrigexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_ACTION_CREATE,
    WorkTriggerExplorerActionCreate
);

const WorkTriggerExplorerActionClone = require("./lmrbcomponents/worktrigexplorer/actions/clone/CloneAction");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_ACTION_CLONE,
    WorkTriggerExplorerActionClone
);

const WorkTriggerExplorerActionDelete = require("./lmrbcomponents/worktrigexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.WORK_TRIGGER_EXPLORER_ACTION_DELETE,
    WorkTriggerExplorerActionDelete
);

/*** WORK TRIGGER EDITOR ***/

const Wte = require("./editors/worktriginstanceeditor/WorkTriggerInstanceEditor");
Steve.di.registry.register(Registrations.WORK_TRIGGER_INSTANCE_EDITOR, Wte);

/*** WORK TRIGGER EDITOR VIEWS ***/

const WteViewDetails = require("./editors/worktriginstanceeditor/views/worktrig_details/WorkTriggerDetailsViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_DETAILS, WteViewDetails);

const WteViewActivity = require("./editors/worktriginstanceeditor/views/worktrig_activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_ACTIVITY, WteViewActivity);

const WteViewFutures = require("./editors/worktriginstanceeditor/views/worktrig_future/WorkTrigFutureViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_FUTURES, WteViewFutures);

const WteViewHistory = require("./editors/worktriginstanceeditor/views/worktrig_history/WorkTrigHistoryViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_HISTORY, WteViewHistory);

const WteViewWork = require("./editors/worktriginstanceeditor/subviews/worktrig_work/WorkViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_WORK, WteViewWork);

const WieViewLogs = require("./editors/worktriginstanceeditor/subviews/logs/LogsViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_LOGS, WieViewLogs);

const WieViewTargetResults = require("./editors/worktriginstanceeditor/subviews/worktrig_target_results/TargetResultsViewComponent");
Steve.di.registry.register(Registrations.WTE_VIEW_TARGET_RESULTS, WieViewTargetResults);

/*** WORK TRIGGER EDITOR ACTIONS ***/

const WteActionRun = require("./editors/worktriginstanceeditor/actions/run/RunAction");
Steve.di.registry.register(Registrations.WTE_ACTION_RUN, WteActionRun);

const WteActionPause = require("./editors/worktriginstanceeditor/actions/pause/PauseAction");
Steve.di.registry.register(Registrations.WTE_ACTION_PAUSE, WteActionPause);

const WteActionDelete = require("./editors/worktriginstanceeditor/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.WTE_ACTION_DELETE, WteActionDelete);

/**************/
/* FILE PARTS */
/**************/

/*** FILE EXPLORER ***/

const FileExplorerLmrb = require("./lmrbcomponents/fileexplorer/FileExplorerLmrbComponent");
Steve.di.registry.register(Registrations.FILE_EXPLORER_LMRB, FileExplorerLmrb);

/*** FILE EXPLORER VIEWS ***/

const FileExplorerView = require("./lmrbcomponents/fileexplorer/views/file_grid_view/FileGridViewComponent");
Steve.di.registry.register(Registrations.FILE_EXPLORER_GRID, FileExplorerView);

const StatusBarView = require("./lmrbcomponents/fileexplorer/views/file_server_status/FileServerStatusComponent");
Steve.di.registry.register(Registrations.FILE_EXPLORER_STATUS_BAR, StatusBarView);

/*** FILE EXPLORER ACTIONS ***/

const FileExplorerActionCreate = require("./lmrbcomponents/fileexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.FILE_EXPLORER_ACTION_CREATE_FILE,
    FileExplorerActionCreate
);

const FileExplorerActionDelete = require("./lmrbcomponents/fileexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.FILE_EXPLORER_ACTION_DELETE_FILE,
    FileExplorerActionDelete
);

const FileExplorerActionEdit = require("./lmrbcomponents/fileexplorer/actions/edit/EditAction");
Steve.di.registry.register(Registrations.FILE_EXPLORER_ACTION_EDIT_FILE, FileExplorerActionEdit);

const FileExplorerActionCreateFolder = require("./lmrbcomponents/fileexplorer/actions/createfolder/CreateFolderAction");
Steve.di.registry.register(
    Registrations.FILE_EXPLORER_ACTION_CREATE_FOLDER,
    FileExplorerActionCreateFolder
);

const FileExplorerActionDeleteFolder = require("./lmrbcomponents/fileexplorer/actions/deletefolder/DeleteFolderAction");
Steve.di.registry.register(
    Registrations.FILE_EXPLORER_ACTION_DELETE_FOLDER,
    FileExplorerActionDeleteFolder
);

const FileExplorerActionRenameFolder = require("./lmrbcomponents/fileexplorer/actions/renamefolder/RenameFolderAction");
Steve.di.registry.register(
    Registrations.FILE_EXPLORER_ACTION_RENAME_FOLDER,
    FileExplorerActionRenameFolder
);

/*** FILE EDITOR ***/

const FileEditor = require("./editors/fileinstanceeditor/FileInstanceEditor");
Steve.di.registry.register(Registrations.FILE_INSTANCE_EDITOR, FileEditor);

/*** FILE EDITOR VIEWS ***/

const FileViewDetails = require("./editors/fileinstanceeditor/views/file_details/FileDetailsViewComponent");
Steve.di.registry.register(Registrations.FIE_VIEW_DETAILS, FileViewDetails);

const FileViewMultiEdit = require("./editors/fileinstanceeditor/views/file_multiedit/FileMultiEditViewComponent");
Steve.di.registry.register(Registrations.FILE_VIEW_MULTIEDIT, FileViewMultiEdit);

const FileActivity = require("./editors/fileinstanceeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.FIE_VIEW_ACTIVITY, FileActivity);

/*** FILE EDITOR ACTIONS ***/

const FileDelete = require("./editors/fileinstanceeditor/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.FIE_ACTION_DELETE, FileDelete);

/***********************/
/* DATA EXPLORER PARTS */
/***********************/

const DataExplorerLmrb = require("./lmrbcomponents/dataexplorer/DataExplorerLmrbComponent");
Steve.di.registry.register(Registrations.DATA_EXPLORER_LMRB, DataExplorerLmrb);

const DataExplorerDeviceExplorerEntity = require("./lmrbcomponents/deviceexplorer/DeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(
    Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB,
    DataExplorerDeviceExplorerEntity
);

const DataExplorerIoTDeviceExplorerEntity = require("./lmrbcomponents/iotdeviceexplorer/IotDeviceExplorerEntityLmrbComponent");
Steve.di.registry.register(
    Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB,
    DataExplorerIoTDeviceExplorerEntity
);

const DataExplorerActionSwitchView = require("./lmrbcomponents/dataexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.DATA_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    DataExplorerActionSwitchView
);

const DataExplorerToIotActionSwitchView = require("./lmrbcomponents/dataexplorer/views/switch_to_iot_device_explorer/SwitchToIoTDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.DATA_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER,
    DataExplorerToIotActionSwitchView
);

const DataExplorerDeviceExplorerGridView = require("./lmrbcomponents/deviceexplorer/views/device_grid_view/DeviceGridViewComponent");
Steve.di.registry.register(
    Registrations.DATA_EXPLORER_DEVICE_VIEW_GRID,
    DataExplorerDeviceExplorerGridView
);

/*** DATA EXPLORER VIEWS ***/

const DataExplorerView = require("./lmrbcomponents/dataexplorer/views/data_explorer_grid_view/DataExplorerGridViewComponent");
Steve.di.registry.register(Registrations.DATA_EXPLORER_GRID, DataExplorerView);

/*** DATA EXPLORER ACTIONS ***/

const DataExplorerActionCreate = require("./lmrbcomponents/dataexplorer/actions/create/CreateAction");
Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_CREATE, DataExplorerActionCreate);

const DataExplorerActionDelete = require("./lmrbcomponents/dataexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_DELETE, DataExplorerActionDelete);

const DataExplorerActionClone = require("./lmrbcomponents/dataexplorer/actions/clone/CloneAction");
Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_CLONE, DataExplorerActionClone);

const DataExplorerActionExport = require("./lmrbcomponents/dataexplorer/actions/export/ExportAction");
Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_EXPORT, DataExplorerActionExport);

const DataExplorerActionImport = require("./lmrbcomponents/dataexplorer/actions/import/ImportAction");
Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_IMPORT, DataExplorerActionImport);

const DataExplorerActionEdit = require("./lmrbcomponents/dataexplorer/actions/edit/EditAction");
Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_EDIT, DataExplorerActionEdit);

// const DataExplorerActionRun = require("./lmrbcomponents/dataexplorer/actions/run/RunAction");
// Steve.di.registry.register(Registrations.DATA_EXPLORER_ACTIONS_RUN, DataExplorerActionRun);

/*** DATA EDITOR ***/

const DataEditor = require("./editors/dataexporerinstanceeditor/DataInstanceEditor");
Steve.di.registry.register(Registrations.DATA_INSTANCE_EDITOR, DataEditor);

// /*** DATA EDITOR VIEWS ***/

const DataViewDetails = require("./editors/dataexporerinstanceeditor/views/data_explorer_details/DataExplorerDetailsViewComponent");
Steve.di.registry.register(Registrations.DEIE_VIEW_DETAILS, DataViewDetails);

const DataActivity = require("./editors/dataexporerinstanceeditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.DEIE_VIEW_ACTIVITY, DataActivity);
const DataResult = require("./editors/dataexporerinstanceeditor/views/data_explorer_results/DataExplorerResultsViewComponent");
Steve.di.registry.register(Registrations.DEIE_VIEW_RESULT, DataResult);

/*** DATA EDITOR ACTIONS ***/

/*************************/
/* VERSION CONTROL PARTS */
/*************************/

/*** VERSION CONTROL EXPLORER ***/

const VersionControlExplorerLmrb = require("./lmrbcomponents/versioncontrolexplorer/VersionControlExplorerLmrbComponent");
Steve.di.registry.register(Registrations.VERSION_CONTROL_EXPLORER_LMRB, VersionControlExplorerLmrb);

/*** VERSION CONTROL EXPLORER VIEWS ***/

const VersionControlExplorerView = require("./lmrbcomponents/versioncontrolexplorer/views/version_control_grid_view/VersionControlGridViewComponent");
Steve.di.registry.register(Registrations.VERSION_CONTROL_EXPLORER_GRID, VersionControlExplorerView);

/*** VERSION CONTROL EXPLORER ACTIONS ***/

const VersionControlExplorerActionCommitPush = require("./lmrbcomponents/versioncontrolexplorer/actions/commitpush/CommitPushAction");
Steve.di.registry.register(
    Registrations.VERSION_CONTROL_ACTION_COMMIT_PUSH,
    VersionControlExplorerActionCommitPush
);

/*** VERSION CONTROL EDITOR ***/

const VersionControlEditor = require("./editors/versioncontrolinstanceeditor/VersionControlInstanceEditor");
Steve.di.registry.register(Registrations.VERSION_CONTROL_INSTANCE_EDITOR, VersionControlEditor);

/*** VERSION CONTROL EDITOR VIEWS ***/

const VersionControlViewDetails = require("./editors/versioncontrolinstanceeditor/views/version_control_details/VersionControlDetailsViewComponent");
Steve.di.registry.register(Registrations.VERSION_CONTROL_VIEW_DETAILS, VersionControlViewDetails);

/*************************/
/* IOT OS PLAN PARTS     */
/*************************/

/*** IOT OS PLAN EXPLORER ***/

const IotOsPlanExplorerLmrb = require("./lmrbcomponents/iotosplanexplorer/IotOsPlanExplorerLmrbComponent");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EXPLORER_LMRB, IotOsPlanExplorerLmrb);

/*** IOT OS PLAN EXPLORER VIEWS ***/

const IotOsPlanExplorerView = require("./lmrbcomponents/iotosplanexplorer/views/iot_os_plan_grid_view/IotOsPlanGridViewComponent");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EXPLORER_GRID, IotOsPlanExplorerView);

const IotOsPlanActionSwitchView = require("./lmrbcomponents/iotosplanexplorer/views/switch_to_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_SWITCH_TO_DEVICE_EXPLORER,
    IotOsPlanActionSwitchView
);

const IotOsPlanActionSwitchToOsExplorerView = require("./lmrbcomponents/iotosplanexplorer/views/switch_to_os_plan/SwitchToOsPlanComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_SWITCH_TO_OS_PLAN_EXPLORER,
    IotOsPlanActionSwitchToOsExplorerView
);

const IotOsPlanActionSwitchToPlatformExplorerView = require("./lmrbcomponents/iotosplanexplorer/views/switch_to_platform_explorer/SwitchToPlatformComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER,
    IotOsPlanActionSwitchToPlatformExplorerView
);

const IotOsPlanActionSwitchToIoTExplorerView = require("./lmrbcomponents/iotosplanexplorer/views/switch_to_iot_device_explorer/SwitchToDeviceExplorerComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER,
    IotOsPlanActionSwitchToIoTExplorerView
);

/*** IOT OS PLAN EXPLORER ACTIONS ***/

const IotOsPlanExplorerActionCreate = require("./lmrbcomponents/iotosplanexplorer/actions/create/CreateAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_CREATE,
    IotOsPlanExplorerActionCreate
);

const IotOsPlanExplorerActionDelete = require("./lmrbcomponents/iotosplanexplorer/actions/delete/DeleteAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_DELETE,
    IotOsPlanExplorerActionDelete
);

const IotOsPlanExplorerActionClone = require("./lmrbcomponents/iotosplanexplorer/actions/clone/CloneAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_CLONE,
    IotOsPlanExplorerActionClone
);

const IotOsPlanExplorerActionExport = require("./lmrbcomponents/iotosplanexplorer/actions/download/DownloadAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_EXPORT,
    IotOsPlanExplorerActionExport
);

const IotOsPlanExplorerActionEdit = require("./lmrbcomponents/iotosplanexplorer/actions/edit/EditAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_EDIT,
    IotOsPlanExplorerActionEdit
);

const IotOsPlanExplorerActionRun = require("./lmrbcomponents/iotosplanexplorer/actions/import/ImportAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EXPLORER_ACTIONS_RUN,
    IotOsPlanExplorerActionRun
);

/*** IOT OS PLAN EDITOR ***/

const IotOsPlanEditor = require("./editors/iotosplaneditor/IotOsPlanEditor");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EDITOR, IotOsPlanEditor);

/*** IOT OS PLAN EDITOR VIEWS ***/

const IotOsPlanDetails = require("./editors/iotosplaneditor/views/iot_os_plan_details/IotOsPlanDetailsViewComponent");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EDITOR_VIEW_DETAILS, IotOsPlanDetails);

const IotOsPlanResults = require("./editors/iotosplaneditor/views/iot_os_plan_results/IotOsPlanResultsViewComponent");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EDITOR_VIEW_RESULTS, IotOsPlanResults);

const IotOsPlanActivity = require("./editors/iotosplaneditor/views/activity/ActivityViewComponent");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EDITOR_VIEW_ACTIVITY, IotOsPlanActivity);

const IotOsPlanImageDetails = require("./editors/iotosplaneditor/views/iot_os_plan_details/subviews/image_details/ImageDetailsComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_SUBVIEW_IMAGE_DETAILS,
    IotOsPlanImageDetails
);

const IotOsPlanValidation = require("./editors/iotosplaneditor/views/iot_os_plan_details/subviews/validate/ValidateViewComponent");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EDITOR_SUBVIEW_VALIDATE, IotOsPlanValidation);

const IotOsPlanResultLogs = require("./editors/iotosplaneditor/views/iot_os_plan_results/subviews/logs/LogsViewComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_SUBVIEW_RESULTS_LOGS,
    IotOsPlanResultLogs
);

const IotOsPlanActivityLogs = require("./editors/iotosplaneditor/views/activity/subviews/logs/LogsViewComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_SUBVIEW_ACTIVITY_LOGS,
    IotOsPlanActivityLogs
);

const IotOsPlanManageDevice = require("./editors/iotosplaneditor/views/iot_os_plan_details/subviews/manage_device/ManageDeviceViewComponent");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_SUBVIEW_MANAGE_DEVICE,
    IotOsPlanManageDevice
);

/*** IOT OS PLAN EDITOR ACTIONS ***/

const IotOsPlanEditorDelete = require("./editors/iotosplaneditor/actions/delete/DeleteAction");
Steve.di.registry.register(Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_DELETE, IotOsPlanEditorDelete);

const IotOsPlanEditorOfflineUpgradeDownload = require("./editors/iotosplaneditor/actions/offlineupgradedownload/OfflineUpgradeDownloadAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_DOWNLOAD,
    IotOsPlanEditorOfflineUpgradeDownload
);

const IotOsPlanEditorOfflineUpgradeUpload = require("./editors/iotosplaneditor/actions/offlineupgradeupload/OfflineUpgradeUploadAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_UPLOAD,
    IotOsPlanEditorOfflineUpgradeUpload
);

const IotOsPlanEditorUploadImage = require("./editors/iotosplaneditor/actions/uploadimage/UploadImageAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_UPLOAD_IMAGE,
    IotOsPlanEditorUploadImage
);

const IotOsPlanEditorUpdateDeviceStatuses = require("./editors/iotosplaneditor/actions/updatedevicestatuses/UpdateDeviceStatusesAction");
Steve.di.registry.register(
    Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_UPDATE_DEVICE_STATUSES,
    IotOsPlanEditorUpdateDeviceStatuses
);
